import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { FiMail, FiLock, FiShield } from 'react-icons/fi';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/shared/components/ui/Button';
import { Input } from '@/shared/components/ui/Input';
import { FormField } from '@/shared/components/ui/FormField';
import { toast } from 'sonner';

const loginSchema = z.object({
  email: z.string().email('Email inválido'),
  password: z.string().min(6, 'Mínimo 6 caracteres'),
});

type LoginFormData = z.infer<typeof loginSchema>;

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm<LoginFormData>({
    resolver: zodResolver(loginSchema),
  });

  const onSubmit = async (data: LoginFormData) => {
    try {
      setIsLoading(true);
      await login(data);
      toast.success('Login realizado com sucesso!');
      navigate('/');
    } catch {
      toast.error('Credenciais inválidas');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ backgroundColor: '#f8fafc' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl mb-4" style={{ backgroundColor: '#8b5cf6' }}>
            <FiShield className="h-7 w-7 text-white" />
          </div>
          <h1 className="text-2xl font-bold" style={{ color: '#1e293b' }}>Admin Panel</h1>
          <p className="text-sm mt-1" style={{ color: '#6b7280' }}>Acesse o painel de administração</p>
        </div>

        <div className="rounded-xl border p-6" style={{ backgroundColor: '#ffffff', borderColor: 'rgba(0,0,0,0.06)' }}>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <FormField label="Email" error={errors.email?.message} required>
              <Input
                type="email"
                placeholder="admin@exemplo.com"
                icon={FiMail}
                error={errors.email?.message}
                {...register('email')}
              />
            </FormField>

            <FormField label="Senha" error={errors.password?.message} required>
              <Input
                type="password"
                placeholder="Sua senha"
                icon={FiLock}
                error={errors.password?.message}
                {...register('password')}
              />
            </FormField>

            <Button type="submit" fullWidth loading={isLoading} size="lg">
              Entrar
            </Button>
          </form>
        </div>

        <p className="text-center text-sm mt-6" style={{ color: '#6b7280' }}>
          Ainda não tem um painel?{' '}
          <Link to="/register" className="font-medium" style={{ color: '#8b5cf6' }}>
            Registrar App
          </Link>
        </p>
      </div>
    </div>
  );
};
